import { Suspense, lazy, useEffect } from "react";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { useDispatch } from "react-redux";
import { bookButtonActions } from "store/bookButton/bookButtonSlice";

const UserBookStatusMapSync = lazy(() => import("./UserBookStatusMapSync"));

export default function BootstrapCurrentUser() {
  const loggedIn = useIsLoggedIn();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loggedIn) {
      dispatch(bookButtonActions.setUserBookStatusMap({}));
    }
  }, [loggedIn, dispatch]);

  if (!loggedIn) {
    return null;
  }

  return (
    <Suspense>
      <UserBookStatusMapSync />
    </Suspense>
  );
}
